// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwapOutlinedSvg from "@ant-design/icons-svg/es/asn/SwapOutlined";
import AntdIcon from '../components/AntdIcon';

var SwapOutlined = function SwapOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwapOutlinedSvg
  }));
};

SwapOutlined.displayName = 'SwapOutlined';
export default React.forwardRef(SwapOutlined);